export type MetricCounterPayload = {
  name: string;
  tags?: Record<string, string>;
  value?: number;
};

const CLIENT_CORRELATION_ID_KEY = "wavvest_client_correlation_id";

const generateClientCorrelationId = () => {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }

  return `client-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
};

export function getClientCorrelationId() {
  if (typeof window === "undefined") {
    return "server";
  }

  try {
    const existingId = window.localStorage.getItem(CLIENT_CORRELATION_ID_KEY);

    if (existingId) {
      return existingId;
    }

    const newId = generateClientCorrelationId();
    window.localStorage.setItem(CLIENT_CORRELATION_ID_KEY, newId);
    return newId;
  } catch {
    return generateClientCorrelationId();
  }
}

export function incrementMetricCounter({
  name,
  tags = {},
  value = 1,
}: MetricCounterPayload) {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent("wavvest:metric", {
      detail: {
        type: "counter",
        name,
        value,
        tags,
        timestamp: Date.now(),
      },
    }),
  );
}
